import { html } from "lit";
import { getDummyText } from "../../../../utils";

const dummyVideoPoster = `data:image/svg+xml,<svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"0 0 1600 900" style%3D"background%3A %23e7e7e7"> <svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"-22.4 -37.5 135 165"> <path fill%3D"%23a1a1a1" d%3D"M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z"%2F> <%2Fsvg> <%2Fsvg>`;

export const dummyVideo = {
    videoSrc:
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    poster: dummyVideoPoster,
    playAgainText: "Ereneut Abspielen",
    toVideoText: "Produktseite Ansehen",
    videoTitle: getDummyText(123),
    videoLink: "#",
    duration: "6:34 min",
};

export const dummyVideos = Array(10).fill({ ...dummyVideo });

export const TeaserVideoTemplate = ({
    videoSrc = "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    playAgainText = "Ereneut Abspielen",
    poster = dummyVideoPoster,
    toVideoText = "Produktseite Ansehen",
    videoTitle = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    videoLink = "#",
    duration = "6:34 min",
}) => html`
    <ux-iws-teaser-video-search
        play-again-text="${playAgainText}"
        video-title="${videoTitle}"
    >
        <video preload="none" poster="${poster}" slot="video">
            <source src="${videoSrc}" type="video/mp4" />
            <source
                src="${videoSrc}"
                type="video/mp4"
                media="all and (max-width: 480px)"
            />
        </video>
        <a slot="link" class="ux-button ux-button--green" href="${videoLink}"
            >${toVideoText}</a
        >
        <span class="ux-u-text-uppercase ux-text-tiny ux-text-tiny--bold"
            >${duration}</span
        >
        <ux-text-lines-limit
            text-lines-s="4"
            text-lines-m="2"
            text-lines-l="2"
            text-lines-xl="2"
        >
            <p class="ux-iws-teaser-video-search__title ux-text-title-teaser">
                ${videoTitle}
            </p>
        </ux-text-lines-limit>
    </ux-iws-teaser-video-search>
`;
